import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Register.css";

function Register() {
  const navigate = useNavigate();

  const handleGoogleLogin = () => {
  window.location.href = `https://devskillz-ifm6.onrender.com/api/auth/google`; 
};


const REGISTER_API = `https://devskillz-ifm6.onrender.com/api/student/register`;

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    dob: "",
    college: "",
    username: "",
    password: "",
  });

  const [errors, setErrors] = useState({});

  const regex = {
    name: /^[A-Za-z\s]{2,30}$/,
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    phone: /^[6-9]\d{9}$/,
    username: /^[a-zA-Z0-9_]{4,16}$/,
    password: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/,
  };

  const validate = () => {
    const newErrors = {};
    if (!regex.name.test(formData.firstName)) newErrors.firstName = "Enter a valid first name.";
    if (!regex.name.test(formData.lastName)) newErrors.lastName = "Enter a valid last name.";
    if (!regex.email.test(formData.email)) newErrors.email = "Enter a valid email.";
    if (!regex.phone.test(formData.phone)) newErrors.phone = "Enter a valid phone number.";
    if (!formData.dob) newErrors.dob = "Date of Birth is required.";
    if (!formData.college.trim()) newErrors.college = "College name is required.";
    if (!regex.username.test(formData.username)) newErrors.username = "Username must be 4–16 chars.";
    if (!regex.password.test(formData.password)) newErrors.password = "Password must be 6+ chars with letters & numbers.";
    return newErrors;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleRegister = async (e) => {
    e.preventDefault();

    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      const res = await axios.post(REGISTER_API, formData, {
        withCredentials: true,
      });

      if (res.data.userId) {
        alert("OTP sent to your email");
        navigate(`/verify-otp/${res.data.userId}`);
      }
    } catch (err) {
      console.log(err);
      alert(err.response?.data?.error || "❌ Server error. Please try again.");
    }
  };

  return (
    <div className="register-page">
      <div className="register-box">
        <h2>Create Account</h2>
        <p className="subtitle">Sign up to get started</p>

        <form onSubmit={handleRegister} className="register-form">
          <div className="form-grid">
            <div>
              <input type="text" name="firstName" placeholder="First Name" value={formData.firstName} onChange={handleChange} required />
              {errors.firstName && <p className="error">{errors.firstName}</p>}
            </div>

            <div>
              <input type="text" name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleChange} required />
              {errors.lastName && <p className="error">{errors.lastName}</p>}
            </div>

            <div>
              <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
              {errors.email && <p className="error">{errors.email}</p>}
            </div>

            <div>
              <input type="tel" name="phone" placeholder="Phone" value={formData.phone} onChange={handleChange} required />
              {errors.phone && <p className="error">{errors.phone}</p>}
            </div>

            <div>
              <input type="date" name="dob" value={formData.dob} onChange={handleChange} required />
              {errors.dob && <p className="error">{errors.dob}</p>}
            </div>

            <div>
              <input type="text" name="college" placeholder="College Name" value={formData.college} onChange={handleChange} required />
              {errors.college && <p className="error">{errors.college}</p>}
            </div>

            <div>
              <input type="text" name="username" placeholder="Username" value={formData.username} onChange={handleChange} required />
              {errors.username && <p className="error">{errors.username}</p>}
            </div>

            <div>
              <input type="password" name="password" placeholder="Password" value={formData.password} onChange={handleChange} required />
              {errors.password && <p className="error">{errors.password}</p>}
            </div>
          </div>

          <button type="submit" className="submit-btn">Register</button>

          <button 
  type="button" 
  className="google-btn" 
  onClick={handleGoogleLogin}
>
  <img 
    src="https://developers.google.com/identity/images/g-logo.png" 
    alt="Google" 
    style={{ width: "20px", marginRight: "10px" }} 
  />
  Sign Up with Google
</button>


          <div className="login-redirect">
            Already have an account?{" "}
            <span onClick={() => navigate("/login")} className="login-link">
              Login
            </span>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Register;
